var map = {
	"./Clothes/Black/0.png": "28e9",
	"./Clothes/Black/1.png": "d4c8",
	"./Clothes/Black/10.png": "95b9",
	"./Clothes/Black/11.png": "0739",
	"./Clothes/Black/2.png": "287c",
	"./Clothes/Black/3.png": "9bda",
	"./Clothes/Black/4.png": "554f",
	"./Clothes/Black/5.png": "584e",
	"./Clothes/Black/6.png": "f700",
	"./Clothes/Black/7.png": "2018",
	"./Clothes/Black/8.png": "0e40",
	"./Clothes/Black/9.png": "88c1",
	"./Clothes/Blonde/0.png": "bbad",
	"./Clothes/Blonde/1.png": "c9da",
	"./Clothes/Blonde/10.png": "a753",
	"./Clothes/Blonde/11.png": "cf8b",
	"./Clothes/Blonde/2.png": "2f36",
	"./Clothes/Blonde/3.png": "155b",
	"./Clothes/Blonde/4.png": "1e17",
	"./Clothes/Blonde/5.png": "41dc",
	"./Clothes/Blonde/6.png": "62f8",
	"./Clothes/Blonde/7.png": "b26f",
	"./Clothes/Blonde/8.png": "0c6e",
	"./Clothes/Blonde/9.png": "5f1c",
	"./Clothes/Blue Green/0.png": "1332",
	"./Clothes/Blue Green/1.png": "d6a6",
	"./Clothes/Blue Green/10.png": "6e66",
	"./Clothes/Blue Green/11.png": "6c3b",
	"./Clothes/Blue Green/2.png": "0a7b",
	"./Clothes/Blue Green/3.png": "83b7",
	"./Clothes/Blue Green/4.png": "d319",
	"./Clothes/Blue Green/5.png": "7584",
	"./Clothes/Blue Green/6.png": "887d",
	"./Clothes/Blue Green/7.png": "f715",
	"./Clothes/Blue Green/8.png": "61b0",
	"./Clothes/Blue Green/9.png": "381f",
	"./Clothes/Blue/0.png": "d913",
	"./Clothes/Blue/1.png": "a1e1",
	"./Clothes/Blue/10.png": "df0a",
	"./Clothes/Blue/11.png": "81c7",
	"./Clothes/Blue/2.png": "8d3d",
	"./Clothes/Blue/3.png": "346e",
	"./Clothes/Blue/4.png": "e3ce",
	"./Clothes/Blue/5.png": "05e7",
	"./Clothes/Blue/6.png": "5c4f",
	"./Clothes/Blue/7.png": "0761",
	"./Clothes/Blue/8.png": "c726",
	"./Clothes/Blue/9.png": "67ea",
	"./Clothes/Brown/0.png": "8af2",
	"./Clothes/Brown/1.png": "6d58",
	"./Clothes/Brown/10.png": "c87b",
	"./Clothes/Brown/11.png": "f47a",
	"./Clothes/Brown/2.png": "142a",
	"./Clothes/Brown/3.png": "bc3a",
	"./Clothes/Brown/4.png": "7c69",
	"./Clothes/Brown/5.png": "534e",
	"./Clothes/Brown/6.png": "dc3c",
	"./Clothes/Brown/7.png": "1bbb",
	"./Clothes/Brown/8.png": "9d44",
	"./Clothes/Brown/9.png": "eecf",
	"./Clothes/Dark Blue/0.png": "b4c4",
	"./Clothes/Dark Blue/1.png": "451c",
	"./Clothes/Dark Blue/10.png": "8ec7",
	"./Clothes/Dark Blue/11.png": "69ee",
	"./Clothes/Dark Blue/2.png": "9869",
	"./Clothes/Dark Blue/3.png": "ca74",
	"./Clothes/Dark Blue/4.png": "cdee",
	"./Clothes/Dark Blue/5.png": "e05a",
	"./Clothes/Dark Blue/6.png": "5c6e",
	"./Clothes/Dark Blue/7.png": "b158",
	"./Clothes/Dark Blue/8.png": "dd0b",
	"./Clothes/Dark Blue/9.png": "77aa",
	"./Clothes/Dark Brown/0.png": "b248",
	"./Clothes/Dark Brown/1.png": "97a0",
	"./Clothes/Dark Brown/10.png": "8387",
	"./Clothes/Dark Brown/11.png": "a369",
	"./Clothes/Dark Brown/2.png": "8659",
	"./Clothes/Dark Brown/3.png": "69fc",
	"./Clothes/Dark Brown/4.png": "142b",
	"./Clothes/Dark Brown/5.png": "da7b",
	"./Clothes/Dark Brown/6.png": "f088",
	"./Clothes/Dark Brown/7.png": "570a",
	"./Clothes/Dark Brown/8.png": "44fc",
	"./Clothes/Dark Brown/9.png": "f3e4",
	"./Clothes/Green/0.png": "52ea",
	"./Clothes/Green/1.png": "dfb7",
	"./Clothes/Green/10.png": "ef63",
	"./Clothes/Green/11.png": "cac0",
	"./Clothes/Green/2.png": "64a0",
	"./Clothes/Green/3.png": "ec48",
	"./Clothes/Green/4.png": "b6cf",
	"./Clothes/Green/5.png": "dd5b",
	"./Clothes/Green/6.png": "fa62",
	"./Clothes/Green/7.png": "7241",
	"./Clothes/Green/8.png": "98b4",
	"./Clothes/Green/9.png": "d038",
	"./Clothes/Light Brown/0.png": "8188",
	"./Clothes/Light Brown/1.png": "bf88",
	"./Clothes/Light Brown/10.png": "b822",
	"./Clothes/Light Brown/11.png": "69ae",
	"./Clothes/Light Brown/2.png": "5f96",
	"./Clothes/Light Brown/3.png": "f4df",
	"./Clothes/Light Brown/4.png": "df16",
	"./Clothes/Light Brown/5.png": "2a75",
	"./Clothes/Light Brown/6.png": "e7ad",
	"./Clothes/Light Brown/7.png": "34e0",
	"./Clothes/Light Brown/8.png": "b189",
	"./Clothes/Light Brown/9.png": "6f88",
	"./Clothes/Light Green/0.png": "1901",
	"./Clothes/Light Green/1.png": "e22e",
	"./Clothes/Light Green/10.png": "45c8",
	"./Clothes/Light Green/11.png": "73d4",
	"./Clothes/Light Green/2.png": "eaa0",
	"./Clothes/Light Green/3.png": "7835",
	"./Clothes/Light Green/4.png": "3a44",
	"./Clothes/Light Green/5.png": "1783",
	"./Clothes/Light Green/6.png": "5bc0",
	"./Clothes/Light Green/7.png": "94f4",
	"./Clothes/Light Green/8.png": "3908",
	"./Clothes/Light Green/9.png": "f15f",
	"./Clothes/Lilac/0.png": "6eb1",
	"./Clothes/Lilac/1.png": "a925",
	"./Clothes/Lilac/10.png": "723f",
	"./Clothes/Lilac/11.png": "c220",
	"./Clothes/Lilac/2.png": "7a27",
	"./Clothes/Lilac/3.png": "5a19",
	"./Clothes/Lilac/4.png": "5c07",
	"./Clothes/Lilac/5.png": "238d",
	"./Clothes/Lilac/6.png": "9a99",
	"./Clothes/Lilac/7.png": "f347",
	"./Clothes/Lilac/8.png": "dea9",
	"./Clothes/Lilac/9.png": "9eeb",
	"./Clothes/Magenta/0.png": "2675",
	"./Clothes/Magenta/1.png": "3944",
	"./Clothes/Magenta/10.png": "8f87",
	"./Clothes/Magenta/11.png": "e4d0",
	"./Clothes/Magenta/2.png": "0e47",
	"./Clothes/Magenta/3.png": "7278",
	"./Clothes/Magenta/4.png": "de67",
	"./Clothes/Magenta/5.png": "d706",
	"./Clothes/Magenta/6.png": "b7dc",
	"./Clothes/Magenta/7.png": "824b",
	"./Clothes/Magenta/8.png": "85a6",
	"./Clothes/Magenta/9.png": "0375",
	"./Clothes/Orange/0.png": "5c7f",
	"./Clothes/Orange/1.png": "36cf",
	"./Clothes/Orange/10.png": "4e39",
	"./Clothes/Orange/11.png": "5df1",
	"./Clothes/Orange/2.png": "a6d8",
	"./Clothes/Orange/3.png": "7275",
	"./Clothes/Orange/4.png": "0538",
	"./Clothes/Orange/5.png": "2f08",
	"./Clothes/Orange/6.png": "ac4d",
	"./Clothes/Orange/7.png": "b008",
	"./Clothes/Orange/8.png": "9257",
	"./Clothes/Orange/9.png": "b6bf",
	"./Clothes/Pink/0.png": "729b",
	"./Clothes/Pink/1.png": "d25a",
	"./Clothes/Pink/10.png": "6022",
	"./Clothes/Pink/11.png": "b84c",
	"./Clothes/Pink/2.png": "29f0",
	"./Clothes/Pink/3.png": "f1f1",
	"./Clothes/Pink/4.png": "6c6f",
	"./Clothes/Pink/5.png": "eeb6",
	"./Clothes/Pink/6.png": "2695",
	"./Clothes/Pink/7.png": "fc61",
	"./Clothes/Pink/8.png": "0494",
	"./Clothes/Pink/9.png": "08fb",
	"./Clothes/Red/0.png": "99cd",
	"./Clothes/Red/1.png": "446e",
	"./Clothes/Red/10.png": "d059",
	"./Clothes/Red/11.png": "f986",
	"./Clothes/Red/2.png": "15a8",
	"./Clothes/Red/3.png": "9db0",
	"./Clothes/Red/4.png": "3b42",
	"./Clothes/Red/5.png": "8e4c",
	"./Clothes/Red/6.png": "fbe3",
	"./Clothes/Red/7.png": "320d",
	"./Clothes/Red/8.png": "0ed8",
	"./Clothes/Red/9.png": "e049",
	"./Clothes/White/0.png": "83aa",
	"./Clothes/White/1.png": "ed32",
	"./Clothes/White/10.png": "668f",
	"./Clothes/White/11.png": "e1b6",
	"./Clothes/White/2.png": "5c96",
	"./Clothes/White/3.png": "f4ba",
	"./Clothes/White/4.png": "72b4",
	"./Clothes/White/5.png": "b953",
	"./Clothes/White/6.png": "5ef1",
	"./Clothes/White/7.png": "b15f",
	"./Clothes/White/8.png": "f561",
	"./Clothes/White/9.png": "dd7d",
	"./Eyebrows/Black/0.png": "faec",
	"./Eyebrows/Black/1.png": "4b8c",
	"./Eyebrows/Black/10.png": "55f4",
	"./Eyebrows/Black/11.png": "bd39",
	"./Eyebrows/Black/2.png": "079b",
	"./Eyebrows/Black/3.png": "fe82",
	"./Eyebrows/Black/4.png": "defb",
	"./Eyebrows/Black/5.png": "9e6a",
	"./Eyebrows/Black/6.png": "b386",
	"./Eyebrows/Black/7.png": "d49d",
	"./Eyebrows/Black/8.png": "9373",
	"./Eyebrows/Black/9.png": "3bd2",
	"./Eyebrows/Blonde/0.png": "0bff",
	"./Eyebrows/Blonde/1.png": "e911",
	"./Eyebrows/Blonde/10.png": "2fc5",
	"./Eyebrows/Blonde/11.png": "59de",
	"./Eyebrows/Blonde/2.png": "2a38",
	"./Eyebrows/Blonde/3.png": "dfd1",
	"./Eyebrows/Blonde/4.png": "33e6",
	"./Eyebrows/Blonde/5.png": "6a45",
	"./Eyebrows/Blonde/6.png": "94bc",
	"./Eyebrows/Blonde/7.png": "5274",
	"./Eyebrows/Blonde/8.png": "35a9",
	"./Eyebrows/Blonde/9.png": "4958",
	"./Eyebrows/Blue Green/0.png": "7b84",
	"./Eyebrows/Blue Green/1.png": "a769",
	"./Eyebrows/Blue Green/10.png": "b043",
	"./Eyebrows/Blue Green/11.png": "717d",
	"./Eyebrows/Blue Green/2.png": "6f40",
	"./Eyebrows/Blue Green/3.png": "3682",
	"./Eyebrows/Blue Green/4.png": "80b5",
	"./Eyebrows/Blue Green/5.png": "fd8d",
	"./Eyebrows/Blue Green/6.png": "8a80",
	"./Eyebrows/Blue Green/7.png": "8dbd",
	"./Eyebrows/Blue Green/8.png": "04b6",
	"./Eyebrows/Blue Green/9.png": "b1da",
	"./Eyebrows/Blue/0.png": "ef19",
	"./Eyebrows/Blue/1.png": "2599",
	"./Eyebrows/Blue/10.png": "b991",
	"./Eyebrows/Blue/11.png": "bdfd",
	"./Eyebrows/Blue/2.png": "f06a",
	"./Eyebrows/Blue/3.png": "33e3",
	"./Eyebrows/Blue/4.png": "3915",
	"./Eyebrows/Blue/5.png": "6290",
	"./Eyebrows/Blue/6.png": "6e11",
	"./Eyebrows/Blue/7.png": "b55a",
	"./Eyebrows/Blue/8.png": "c647",
	"./Eyebrows/Blue/9.png": "2a8e",
	"./Eyebrows/Brown/0.png": "12a2",
	"./Eyebrows/Brown/1.png": "85b2",
	"./Eyebrows/Brown/10.png": "4db8",
	"./Eyebrows/Brown/11.png": "c519",
	"./Eyebrows/Brown/2.png": "0821",
	"./Eyebrows/Brown/3.png": "f95f",
	"./Eyebrows/Brown/4.png": "359c",
	"./Eyebrows/Brown/5.png": "6bb7",
	"./Eyebrows/Brown/6.png": "601f",
	"./Eyebrows/Brown/7.png": "0392",
	"./Eyebrows/Brown/8.png": "f8ce",
	"./Eyebrows/Brown/9.png": "518b",
	"./Eyebrows/Dark Blue/0.png": "0564",
	"./Eyebrows/Dark Blue/1.png": "664e",
	"./Eyebrows/Dark Blue/10.png": "57c6",
	"./Eyebrows/Dark Blue/11.png": "cf76",
	"./Eyebrows/Dark Blue/2.png": "5d73",
	"./Eyebrows/Dark Blue/3.png": "71f2",
	"./Eyebrows/Dark Blue/4.png": "88a1",
	"./Eyebrows/Dark Blue/5.png": "e9c0",
	"./Eyebrows/Dark Blue/6.png": "90ce",
	"./Eyebrows/Dark Blue/7.png": "4eda",
	"./Eyebrows/Dark Blue/8.png": "b93e",
	"./Eyebrows/Dark Blue/9.png": "35f7",
	"./Eyebrows/Dark Brown/0.png": "30f5",
	"./Eyebrows/Dark Brown/1.png": "513a",
	"./Eyebrows/Dark Brown/10.png": "42e6",
	"./Eyebrows/Dark Brown/11.png": "261f",
	"./Eyebrows/Dark Brown/2.png": "163f",
	"./Eyebrows/Dark Brown/3.png": "9d92",
	"./Eyebrows/Dark Brown/4.png": "cf17",
	"./Eyebrows/Dark Brown/5.png": "7027",
	"./Eyebrows/Dark Brown/6.png": "9e6f",
	"./Eyebrows/Dark Brown/7.png": "7ca7",
	"./Eyebrows/Dark Brown/8.png": "e0e3",
	"./Eyebrows/Dark Brown/9.png": "22c2",
	"./Eyebrows/Green/0.png": "6666",
	"./Eyebrows/Green/1.png": "ad3b",
	"./Eyebrows/Green/10.png": "3241",
	"./Eyebrows/Green/11.png": "a610",
	"./Eyebrows/Green/2.png": "8122",
	"./Eyebrows/Green/3.png": "7404",
	"./Eyebrows/Green/4.png": "af8c",
	"./Eyebrows/Green/5.png": "602c",
	"./Eyebrows/Green/6.png": "ca06",
	"./Eyebrows/Green/7.png": "3fe9",
	"./Eyebrows/Green/8.png": "7d9d",
	"./Eyebrows/Green/9.png": "856c",
	"./Eyebrows/Light Brown/0.png": "43b6",
	"./Eyebrows/Light Brown/1.png": "2a1f",
	"./Eyebrows/Light Brown/10.png": "5249",
	"./Eyebrows/Light Brown/11.png": "520e",
	"./Eyebrows/Light Brown/2.png": "5590",
	"./Eyebrows/Light Brown/3.png": "c67f",
	"./Eyebrows/Light Brown/4.png": "43ad",
	"./Eyebrows/Light Brown/5.png": "ee56",
	"./Eyebrows/Light Brown/6.png": "6ede",
	"./Eyebrows/Light Brown/7.png": "3dba",
	"./Eyebrows/Light Brown/8.png": "d104",
	"./Eyebrows/Light Brown/9.png": "55e0",
	"./Eyebrows/Light Green/0.png": "65a0",
	"./Eyebrows/Light Green/1.png": "97f5",
	"./Eyebrows/Light Green/10.png": "5827",
	"./Eyebrows/Light Green/11.png": "51da",
	"./Eyebrows/Light Green/2.png": "24cf",
	"./Eyebrows/Light Green/3.png": "06de",
	"./Eyebrows/Light Green/4.png": "12e3",
	"./Eyebrows/Light Green/5.png": "01fe",
	"./Eyebrows/Light Green/6.png": "47ca",
	"./Eyebrows/Light Green/7.png": "1744",
	"./Eyebrows/Light Green/8.png": "e25f",
	"./Eyebrows/Light Green/9.png": "408b",
	"./Eyebrows/Lilac/0.png": "ba79",
	"./Eyebrows/Lilac/1.png": "2b69",
	"./Eyebrows/Lilac/10.png": "c3bd",
	"./Eyebrows/Lilac/11.png": "38c7",
	"./Eyebrows/Lilac/2.png": "9295",
	"./Eyebrows/Lilac/3.png": "c653",
	"./Eyebrows/Lilac/4.png": "fa15",
	"./Eyebrows/Lilac/5.png": "9ba0",
	"./Eyebrows/Lilac/6.png": "f152",
	"./Eyebrows/Lilac/7.png": "3310",
	"./Eyebrows/Lilac/8.png": "ef06",
	"./Eyebrows/Lilac/9.png": "2f1a",
	"./Eyebrows/Magenta/0.png": "9b55",
	"./Eyebrows/Magenta/1.png": "f446",
	"./Eyebrows/Magenta/10.png": "6bd6",
	"./Eyebrows/Magenta/11.png": "2e73",
	"./Eyebrows/Magenta/2.png": "3458",
	"./Eyebrows/Magenta/3.png": "5d76",
	"./Eyebrows/Magenta/4.png": "b69d",
	"./Eyebrows/Magenta/5.png": "1f5c",
	"./Eyebrows/Magenta/6.png": "3b21",
	"./Eyebrows/Magenta/7.png": "d30d",
	"./Eyebrows/Magenta/8.png": "7c94",
	"./Eyebrows/Magenta/9.png": "157f",
	"./Eyebrows/Orange/0.png": "df55",
	"./Eyebrows/Orange/1.png": "89b4",
	"./Eyebrows/Orange/10.png": "d1ef",
	"./Eyebrows/Orange/11.png": "9a9b",
	"./Eyebrows/Orange/2.png": "b415",
	"./Eyebrows/Orange/3.png": "462b",
	"./Eyebrows/Orange/4.png": "d005",
	"./Eyebrows/Orange/5.png": "eed3",
	"./Eyebrows/Orange/6.png": "43a5",
	"./Eyebrows/Orange/7.png": "69b7",
	"./Eyebrows/Orange/8.png": "0f20",
	"./Eyebrows/Orange/9.png": "9a1a",
	"./Eyebrows/Pink/0.png": "d28d",
	"./Eyebrows/Pink/1.png": "9035",
	"./Eyebrows/Pink/10.png": "221e",
	"./Eyebrows/Pink/11.png": "d10d",
	"./Eyebrows/Pink/2.png": "efe5",
	"./Eyebrows/Pink/3.png": "3fad",
	"./Eyebrows/Pink/4.png": "1e3c",
	"./Eyebrows/Pink/5.png": "ccff",
	"./Eyebrows/Pink/6.png": "3dfb",
	"./Eyebrows/Pink/7.png": "c26b",
	"./Eyebrows/Pink/8.png": "2b00",
	"./Eyebrows/Pink/9.png": "ae82",
	"./Eyebrows/Red/0.png": "2ba3",
	"./Eyebrows/Red/1.png": "c214",
	"./Eyebrows/Red/10.png": "65d1",
	"./Eyebrows/Red/11.png": "276b",
	"./Eyebrows/Red/2.png": "a16f",
	"./Eyebrows/Red/3.png": "0255",
	"./Eyebrows/Red/4.png": "c56a",
	"./Eyebrows/Red/5.png": "bb61",
	"./Eyebrows/Red/6.png": "29a1",
	"./Eyebrows/Red/7.png": "ccd1",
	"./Eyebrows/Red/8.png": "9247",
	"./Eyebrows/Red/9.png": "cd5f",
	"./Eyebrows/White/0.png": "68a9",
	"./Eyebrows/White/1.png": "5906",
	"./Eyebrows/White/10.png": "208a",
	"./Eyebrows/White/11.png": "7182",
	"./Eyebrows/White/2.png": "d41a",
	"./Eyebrows/White/3.png": "269d",
	"./Eyebrows/White/4.png": "7b9b",
	"./Eyebrows/White/5.png": "46b5",
	"./Eyebrows/White/6.png": "2c17",
	"./Eyebrows/White/7.png": "914a",
	"./Eyebrows/White/8.png": "e189",
	"./Eyebrows/White/9.png": "b94e",
	"./Eyes/Black/0.png": "c8f4",
	"./Eyes/Black/1.png": "f071",
	"./Eyes/Black/10.png": "005f",
	"./Eyes/Black/11.png": "65a1",
	"./Eyes/Black/2.png": "b4da",
	"./Eyes/Black/3.png": "5ab1",
	"./Eyes/Black/4.png": "9c91",
	"./Eyes/Black/5.png": "d53d",
	"./Eyes/Black/6.png": "7b93",
	"./Eyes/Black/7.png": "9bee",
	"./Eyes/Black/8.png": "fef9",
	"./Eyes/Black/9.png": "80d3",
	"./Eyes/Blonde/0.png": "4c07",
	"./Eyes/Blonde/1.png": "d5e9",
	"./Eyes/Blonde/10.png": "866b",
	"./Eyes/Blonde/11.png": "61d9",
	"./Eyes/Blonde/2.png": "5893",
	"./Eyes/Blonde/3.png": "1c05",
	"./Eyes/Blonde/4.png": "95d4",
	"./Eyes/Blonde/5.png": "df97",
	"./Eyes/Blonde/6.png": "abb0",
	"./Eyes/Blonde/7.png": "9f0b",
	"./Eyes/Blonde/8.png": "0707",
	"./Eyes/Blonde/9.png": "a74d",
	"./Eyes/Blue Green/0.png": "e5cc",
	"./Eyes/Blue Green/1.png": "ddb8",
	"./Eyes/Blue Green/10.png": "a69a",
	"./Eyes/Blue Green/11.png": "2286",
	"./Eyes/Blue Green/2.png": "c8e2",
	"./Eyes/Blue Green/3.png": "53e4",
	"./Eyes/Blue Green/4.png": "8b38",
	"./Eyes/Blue Green/5.png": "725e",
	"./Eyes/Blue Green/6.png": "796a",
	"./Eyes/Blue Green/7.png": "467d",
	"./Eyes/Blue Green/8.png": "bad5",
	"./Eyes/Blue Green/9.png": "8b8a",
	"./Eyes/Blue/0.png": "7d49",
	"./Eyes/Blue/1.png": "3dff",
	"./Eyes/Blue/10.png": "6c61",
	"./Eyes/Blue/11.png": "5ecc",
	"./Eyes/Blue/2.png": "88a6",
	"./Eyes/Blue/3.png": "1ba6",
	"./Eyes/Blue/4.png": "395e",
	"./Eyes/Blue/5.png": "5c8f",
	"./Eyes/Blue/6.png": "4400",
	"./Eyes/Blue/7.png": "4d0e",
	"./Eyes/Blue/8.png": "c6b4",
	"./Eyes/Blue/9.png": "a4b8",
	"./Eyes/Brown/0.png": "b8df",
	"./Eyes/Brown/1.png": "e5bb",
	"./Eyes/Brown/10.png": "fae0",
	"./Eyes/Brown/11.png": "c618",
	"./Eyes/Brown/2.png": "4518",
	"./Eyes/Brown/3.png": "ec8a",
	"./Eyes/Brown/4.png": "a788",
	"./Eyes/Brown/5.png": "9e1e",
	"./Eyes/Brown/6.png": "e04b",
	"./Eyes/Brown/7.png": "c841",
	"./Eyes/Brown/8.png": "2e07",
	"./Eyes/Brown/9.png": "6989",
	"./Eyes/Dark Blue/0.png": "d9df",
	"./Eyes/Dark Blue/1.png": "1b7f",
	"./Eyes/Dark Blue/10.png": "639d",
	"./Eyes/Dark Blue/11.png": "2317",
	"./Eyes/Dark Blue/2.png": "32cb",
	"./Eyes/Dark Blue/3.png": "be19",
	"./Eyes/Dark Blue/4.png": "c268",
	"./Eyes/Dark Blue/5.png": "59be",
	"./Eyes/Dark Blue/6.png": "b411",
	"./Eyes/Dark Blue/7.png": "f05e",
	"./Eyes/Dark Blue/8.png": "4b2b",
	"./Eyes/Dark Blue/9.png": "ce01",
	"./Eyes/Dark Brown/0.png": "395e4",
	"./Eyes/Dark Brown/1.png": "e4f5",
	"./Eyes/Dark Brown/10.png": "2097",
	"./Eyes/Dark Brown/11.png": "deb2",
	"./Eyes/Dark Brown/2.png": "e9b8",
	"./Eyes/Dark Brown/3.png": "3fab",
	"./Eyes/Dark Brown/4.png": "8ee5",
	"./Eyes/Dark Brown/5.png": "86e3",
	"./Eyes/Dark Brown/6.png": "2af6",
	"./Eyes/Dark Brown/7.png": "cc7c",
	"./Eyes/Dark Brown/8.png": "70a5",
	"./Eyes/Dark Brown/9.png": "1f26",
	"./Eyes/Green/0.png": "fe2d",
	"./Eyes/Green/1.png": "a95c",
	"./Eyes/Green/10.png": "2f1a4",
	"./Eyes/Green/11.png": "b9ea",
	"./Eyes/Green/2.png": "d166",
	"./Eyes/Green/3.png": "b060",
	"./Eyes/Green/4.png": "6bc2",
	"./Eyes/Green/5.png": "d4cb",
	"./Eyes/Green/6.png": "d4c1",
	"./Eyes/Green/7.png": "d19f",
	"./Eyes/Green/8.png": "6a7a",
	"./Eyes/Green/9.png": "18dd",
	"./Eyes/Light Brown/0.png": "ceb6",
	"./Eyes/Light Brown/1.png": "7961",
	"./Eyes/Light Brown/10.png": "3519",
	"./Eyes/Light Brown/11.png": "4c64",
	"./Eyes/Light Brown/2.png": "c7e8",
	"./Eyes/Light Brown/3.png": "50d6",
	"./Eyes/Light Brown/4.png": "45f9",
	"./Eyes/Light Brown/5.png": "5f73",
	"./Eyes/Light Brown/6.png": "f4c8",
	"./Eyes/Light Brown/7.png": "8448",
	"./Eyes/Light Brown/8.png": "a9ab",
	"./Eyes/Light Brown/9.png": "8a89",
	"./Eyes/Light Green/0.png": "5afe",
	"./Eyes/Light Green/1.png": "ae74",
	"./Eyes/Light Green/10.png": "3ebc",
	"./Eyes/Light Green/11.png": "504d",
	"./Eyes/Light Green/2.png": "c5a6",
	"./Eyes/Light Green/3.png": "8c73",
	"./Eyes/Light Green/4.png": "f2ac",
	"./Eyes/Light Green/5.png": "0ba6",
	"./Eyes/Light Green/6.png": "302f",
	"./Eyes/Light Green/7.png": "fe90",
	"./Eyes/Light Green/8.png": "6f70",
	"./Eyes/Light Green/9.png": "f4bd",
	"./Eyes/Lilac/0.png": "973a",
	"./Eyes/Lilac/1.png": "4f2d",
	"./Eyes/Lilac/10.png": "30cb",
	"./Eyes/Lilac/11.png": "260a",
	"./Eyes/Lilac/2.png": "9fe5",
	"./Eyes/Lilac/3.png": "820e",
	"./Eyes/Lilac/4.png": "043b",
	"./Eyes/Lilac/5.png": "56a2",
	"./Eyes/Lilac/6.png": "04b3",
	"./Eyes/Lilac/7.png": "4d0c",
	"./Eyes/Lilac/8.png": "865b",
	"./Eyes/Lilac/9.png": "c16d",
	"./Eyes/Magenta/0.png": "6050",
	"./Eyes/Magenta/1.png": "e494",
	"./Eyes/Magenta/10.png": "6b94",
	"./Eyes/Magenta/11.png": "9af6",
	"./Eyes/Magenta/2.png": "2beb",
	"./Eyes/Magenta/3.png": "2d36",
	"./Eyes/Magenta/4.png": "c34b",
	"./Eyes/Magenta/5.png": "fa07",
	"./Eyes/Magenta/6.png": "74f4",
	"./Eyes/Magenta/7.png": "d8ec",
	"./Eyes/Magenta/8.png": "c6e9",
	"./Eyes/Magenta/9.png": "14af",
	"./Eyes/Orange/0.png": "4738",
	"./Eyes/Orange/1.png": "0efe",
	"./Eyes/Orange/10.png": "c44c",
	"./Eyes/Orange/11.png": "25dd",
	"./Eyes/Orange/2.png": "4ea1",
	"./Eyes/Orange/3.png": "7839",
	"./Eyes/Orange/4.png": "0a11",
	"./Eyes/Orange/5.png": "ece6",
	"./Eyes/Orange/6.png": "9d8d",
	"./Eyes/Orange/7.png": "a87d",
	"./Eyes/Orange/8.png": "f86a",
	"./Eyes/Orange/9.png": "c862",
	"./Eyes/Pink/0.png": "c69c",
	"./Eyes/Pink/1.png": "c472",
	"./Eyes/Pink/10.png": "1599",
	"./Eyes/Pink/11.png": "9a92",
	"./Eyes/Pink/2.png": "c73e",
	"./Eyes/Pink/3.png": "bd02",
	"./Eyes/Pink/4.png": "5416",
	"./Eyes/Pink/5.png": "89ec",
	"./Eyes/Pink/6.png": "7341",
	"./Eyes/Pink/7.png": "fdfd",
	"./Eyes/Pink/8.png": "15c2",
	"./Eyes/Pink/9.png": "4965",
	"./Eyes/Red/0.png": "6914",
	"./Eyes/Red/1.png": "132e",
	"./Eyes/Red/10.png": "3125",
	"./Eyes/Red/11.png": "0909",
	"./Eyes/Red/2.png": "2f41",
	"./Eyes/Red/3.png": "e34e",
	"./Eyes/Red/4.png": "1dcc",
	"./Eyes/Red/5.png": "ddb3",
	"./Eyes/Red/6.png": "22a5",
	"./Eyes/Red/7.png": "773d",
	"./Eyes/Red/8.png": "9b19",
	"./Eyes/Red/9.png": "28f7",
	"./Eyes/White/0.png": "7b03",
	"./Eyes/White/1.png": "86d3",
	"./Eyes/White/10.png": "ef84",
	"./Eyes/White/11.png": "79a7",
	"./Eyes/White/2.png": "f972",
	"./Eyes/White/3.png": "dcd4",
	"./Eyes/White/4.png": "0011",
	"./Eyes/White/5.png": "6b20",
	"./Eyes/White/6.png": "b0e3",
	"./Eyes/White/7.png": "40dc",
	"./Eyes/White/8.png": "5ff7",
	"./Eyes/White/9.png": "b624",
	"./Hair/Black/0.png": "ab26",
	"./Hair/Black/1.png": "318a",
	"./Hair/Black/10.png": "d6b1",
	"./Hair/Black/11.png": "c589",
	"./Hair/Black/12.png": "8d7d",
	"./Hair/Black/13.png": "d28b",
	"./Hair/Black/14.png": "7cbf",
	"./Hair/Black/15.png": "a65f",
	"./Hair/Black/16.png": "3660",
	"./Hair/Black/17.png": "ee95",
	"./Hair/Black/18.png": "7c0e",
	"./Hair/Black/19.png": "c664",
	"./Hair/Black/2.png": "730d",
	"./Hair/Black/20.png": "42ef",
	"./Hair/Black/21.png": "43da",
	"./Hair/Black/22.png": "6dc1",
	"./Hair/Black/23.png": "2e4a",
	"./Hair/Black/24.png": "5bfe",
	"./Hair/Black/25.png": "21da",
	"./Hair/Black/26.png": "8dc5",
	"./Hair/Black/27.png": "82ed",
	"./Hair/Black/28.png": "e94f",
	"./Hair/Black/29.png": "8b50",
	"./Hair/Black/3.png": "e89d",
	"./Hair/Black/30.png": "0c39",
	"./Hair/Black/31.png": "3b36",
	"./Hair/Black/4.png": "3fd1",
	"./Hair/Black/5.png": "6e6d",
	"./Hair/Black/6.png": "d875",
	"./Hair/Black/7.png": "c47e",
	"./Hair/Black/8.png": "c8cd",
	"./Hair/Black/9.png": "f32f",
	"./Hair/Blonde/0.png": "fbed",
	"./Hair/Blonde/1.png": "a397",
	"./Hair/Blonde/10.png": "b899",
	"./Hair/Blonde/11.png": "2c23",
	"./Hair/Blonde/12.png": "8774",
	"./Hair/Blonde/13.png": "0ad8",
	"./Hair/Blonde/14.png": "8cf6",
	"./Hair/Blonde/15.png": "c618b",
	"./Hair/Blonde/16.png": "67ce",
	"./Hair/Blonde/17.png": "217c",
	"./Hair/Blonde/18.png": "317e",
	"./Hair/Blonde/19.png": "b68e",
	"./Hair/Blonde/2.png": "b7fe",
	"./Hair/Blonde/20.png": "755f",
	"./Hair/Blonde/21.png": "a17d",
	"./Hair/Blonde/22.png": "bc87",
	"./Hair/Blonde/23.png": "1033",
	"./Hair/Blonde/24.png": "2009",
	"./Hair/Blonde/25.png": "c67d",
	"./Hair/Blonde/26.png": "d98a",
	"./Hair/Blonde/27.png": "24d6",
	"./Hair/Blonde/28.png": "2bfe",
	"./Hair/Blonde/29.png": "0851",
	"./Hair/Blonde/3.png": "79d4",
	"./Hair/Blonde/30.png": "7de7",
	"./Hair/Blonde/31.png": "0ec3",
	"./Hair/Blonde/4.png": "837e",
	"./Hair/Blonde/5.png": "6823",
	"./Hair/Blonde/6.png": "36c0",
	"./Hair/Blonde/7.png": "056d",
	"./Hair/Blonde/8.png": "1482",
	"./Hair/Blonde/9.png": "39a3",
	"./Hair/Blue Green/0.png": "68a0",
	"./Hair/Blue Green/1.png": "377b",
	"./Hair/Blue Green/10.png": "e42f",
	"./Hair/Blue Green/11.png": "ce25",
	"./Hair/Blue Green/12.png": "9bf8",
	"./Hair/Blue Green/13.png": "cd28",
	"./Hair/Blue Green/14.png": "ef98",
	"./Hair/Blue Green/15.png": "7afe",
	"./Hair/Blue Green/16.png": "c363",
	"./Hair/Blue Green/17.png": "7775",
	"./Hair/Blue Green/18.png": "0df0",
	"./Hair/Blue Green/19.png": "4c4d",
	"./Hair/Blue Green/2.png": "fa99",
	"./Hair/Blue Green/20.png": "9f31",
	"./Hair/Blue Green/21.png": "a094",
	"./Hair/Blue Green/22.png": "978e",
	"./Hair/Blue Green/23.png": "1f66",
	"./Hair/Blue Green/24.png": "124a",
	"./Hair/Blue Green/25.png": "58be",
	"./Hair/Blue Green/26.png": "7c0d",
	"./Hair/Blue Green/27.png": "9812",
	"./Hair/Blue Green/28.png": "3041",
	"./Hair/Blue Green/29.png": "6bd7",
	"./Hair/Blue Green/3.png": "d9cd",
	"./Hair/Blue Green/30.png": "85b4",
	"./Hair/Blue Green/31.png": "59ba",
	"./Hair/Blue Green/4.png": "c21f",
	"./Hair/Blue Green/5.png": "036c",
	"./Hair/Blue Green/6.png": "d1fa",
	"./Hair/Blue Green/7.png": "4299",
	"./Hair/Blue Green/8.png": "06e8",
	"./Hair/Blue Green/9.png": "66bb",
	"./Hair/Blue/0.png": "b5e5",
	"./Hair/Blue/1.png": "598e",
	"./Hair/Blue/10.png": "be28",
	"./Hair/Blue/11.png": "0136",
	"./Hair/Blue/12.png": "71d8",
	"./Hair/Blue/13.png": "6898",
	"./Hair/Blue/14.png": "5963",
	"./Hair/Blue/15.png": "5920",
	"./Hair/Blue/16.png": "198b",
	"./Hair/Blue/17.png": "3ac1",
	"./Hair/Blue/18.png": "3ab2",
	"./Hair/Blue/19.png": "1155",
	"./Hair/Blue/2.png": "0c14",
	"./Hair/Blue/20.png": "90b4",
	"./Hair/Blue/21.png": "5beb",
	"./Hair/Blue/22.png": "7cdd",
	"./Hair/Blue/23.png": "0eb9",
	"./Hair/Blue/24.png": "d33b",
	"./Hair/Blue/25.png": "28b0",
	"./Hair/Blue/26.png": "9329",
	"./Hair/Blue/27.png": "c346",
	"./Hair/Blue/28.png": "ec7b",
	"./Hair/Blue/29.png": "474d",
	"./Hair/Blue/3.png": "fd88",
	"./Hair/Blue/30.png": "cb56",
	"./Hair/Blue/31.png": "f147",
	"./Hair/Blue/4.png": "a015",
	"./Hair/Blue/5.png": "6a9e",
	"./Hair/Blue/6.png": "5fac",
	"./Hair/Blue/7.png": "3bcb",
	"./Hair/Blue/8.png": "ed10",
	"./Hair/Blue/9.png": "bd9b",
	"./Hair/Brown/0.png": "f8a7",
	"./Hair/Brown/1.png": "3482",
	"./Hair/Brown/10.png": "5207",
	"./Hair/Brown/11.png": "b48d",
	"./Hair/Brown/12.png": "4b89",
	"./Hair/Brown/13.png": "c3dd",
	"./Hair/Brown/14.png": "7f64",
	"./Hair/Brown/15.png": "847d",
	"./Hair/Brown/16.png": "972a",
	"./Hair/Brown/17.png": "efab",
	"./Hair/Brown/18.png": "0310",
	"./Hair/Brown/19.png": "48c5",
	"./Hair/Brown/2.png": "87a2",
	"./Hair/Brown/20.png": "a921",
	"./Hair/Brown/21.png": "65ee",
	"./Hair/Brown/22.png": "fe50",
	"./Hair/Brown/23.png": "d0b9",
	"./Hair/Brown/24.png": "bd12",
	"./Hair/Brown/25.png": "2375",
	"./Hair/Brown/26.png": "122c",
	"./Hair/Brown/27.png": "854a",
	"./Hair/Brown/28.png": "6551",
	"./Hair/Brown/29.png": "1bca",
	"./Hair/Brown/3.png": "165a",
	"./Hair/Brown/30.png": "b4e9",
	"./Hair/Brown/31.png": "27e6",
	"./Hair/Brown/4.png": "d0b4",
	"./Hair/Brown/5.png": "0c74",
	"./Hair/Brown/6.png": "6c1f",
	"./Hair/Brown/7.png": "ba99",
	"./Hair/Brown/8.png": "94b6",
	"./Hair/Brown/9.png": "48f1",
	"./Hair/Dark Blue/0.png": "96e3",
	"./Hair/Dark Blue/1.png": "60d7",
	"./Hair/Dark Blue/10.png": "47c4",
	"./Hair/Dark Blue/11.png": "b0cf",
	"./Hair/Dark Blue/12.png": "a36f",
	"./Hair/Dark Blue/13.png": "46cd",
	"./Hair/Dark Blue/14.png": "3487",
	"./Hair/Dark Blue/15.png": "1c9a",
	"./Hair/Dark Blue/16.png": "90dc",
	"./Hair/Dark Blue/17.png": "777a",
	"./Hair/Dark Blue/18.png": "151d",
	"./Hair/Dark Blue/19.png": "5fda",
	"./Hair/Dark Blue/2.png": "7dee",
	"./Hair/Dark Blue/20.png": "0faa",
	"./Hair/Dark Blue/21.png": "aec0",
	"./Hair/Dark Blue/22.png": "4f1b",
	"./Hair/Dark Blue/23.png": "1aea",
	"./Hair/Dark Blue/24.png": "b9f6",
	"./Hair/Dark Blue/25.png": "154e",
	"./Hair/Dark Blue/26.png": "07e8",
	"./Hair/Dark Blue/27.png": "40e7",
	"./Hair/Dark Blue/28.png": "2453",
	"./Hair/Dark Blue/29.png": "5397",
	"./Hair/Dark Blue/3.png": "2623",
	"./Hair/Dark Blue/30.png": "0184",
	"./Hair/Dark Blue/31.png": "9f53",
	"./Hair/Dark Blue/4.png": "2a0b",
	"./Hair/Dark Blue/5.png": "b3aa",
	"./Hair/Dark Blue/6.png": "bf5c",
	"./Hair/Dark Blue/7.png": "427d",
	"./Hair/Dark Blue/8.png": "3b6e",
	"./Hair/Dark Blue/9.png": "67e1",
	"./Hair/Dark Brown/0.png": "2fb1",
	"./Hair/Dark Brown/1.png": "081b",
	"./Hair/Dark Brown/10.png": "66be",
	"./Hair/Dark Brown/11.png": "4555",
	"./Hair/Dark Brown/12.png": "ef76",
	"./Hair/Dark Brown/13.png": "70aa",
	"./Hair/Dark Brown/14.png": "89fe",
	"./Hair/Dark Brown/15.png": "10e4",
	"./Hair/Dark Brown/16.png": "3807",
	"./Hair/Dark Brown/17.png": "6d91",
	"./Hair/Dark Brown/18.png": "1663",
	"./Hair/Dark Brown/19.png": "e292",
	"./Hair/Dark Brown/2.png": "2b1d",
	"./Hair/Dark Brown/20.png": "93d8",
	"./Hair/Dark Brown/21.png": "75b6",
	"./Hair/Dark Brown/22.png": "601fb",
	"./Hair/Dark Brown/23.png": "e467d",
	"./Hair/Dark Brown/24.png": "7203",
	"./Hair/Dark Brown/25.png": "1536",
	"./Hair/Dark Brown/26.png": "c6c1",
	"./Hair/Dark Brown/27.png": "81cf",
	"./Hair/Dark Brown/28.png": "5d4b",
	"./Hair/Dark Brown/29.png": "706d",
	"./Hair/Dark Brown/3.png": "4685",
	"./Hair/Dark Brown/30.png": "e15e",
	"./Hair/Dark Brown/31.png": "5304",
	"./Hair/Dark Brown/4.png": "c683",
	"./Hair/Dark Brown/5.png": "99b1",
	"./Hair/Dark Brown/6.png": "6feb",
	"./Hair/Dark Brown/7.png": "1876",
	"./Hair/Dark Brown/8.png": "3356",
	"./Hair/Dark Brown/9.png": "f27d",
	"./Hair/Green/0.png": "b75a",
	"./Hair/Green/1.png": "ac40",
	"./Hair/Green/10.png": "ef17",
	"./Hair/Green/11.png": "e4e5",
	"./Hair/Green/12.png": "2cda",
	"./Hair/Green/13.png": "9bdaf",
	"./Hair/Green/14.png": "80db",
	"./Hair/Green/15.png": "88e6",
	"./Hair/Green/16.png": "ebd8",
	"./Hair/Green/17.png": "cdcc",
	"./Hair/Green/18.png": "cf0a",
	"./Hair/Green/19.png": "dc49",
	"./Hair/Green/2.png": "892a",
	"./Hair/Green/20.png": "e8f3",
	"./Hair/Green/21.png": "148e",
	"./Hair/Green/22.png": "a6ab",
	"./Hair/Green/23.png": "8120",
	"./Hair/Green/24.png": "d468",
	"./Hair/Green/25.png": "71f0",
	"./Hair/Green/26.png": "bbe0",
	"./Hair/Green/27.png": "dad6",
	"./Hair/Green/28.png": "d9f9",
	"./Hair/Green/29.png": "ad4b",
	"./Hair/Green/3.png": "cf0a0",
	"./Hair/Green/30.png": "94c2",
	"./Hair/Green/31.png": "cd0d",
	"./Hair/Green/4.png": "5f46",
	"./Hair/Green/5.png": "799a",
	"./Hair/Green/6.png": "8986",
	"./Hair/Green/7.png": "37fe",
	"./Hair/Green/8.png": "283a",
	"./Hair/Green/9.png": "b7ef",
	"./Hair/Light Brown/0.png": "127d",
	"./Hair/Light Brown/1.png": "ce57",
	"./Hair/Light Brown/10.png": "615f",
	"./Hair/Light Brown/11.png": "121a",
	"./Hair/Light Brown/12.png": "29c0",
	"./Hair/Light Brown/13.png": "32db",
	"./Hair/Light Brown/14.png": "3896",
	"./Hair/Light Brown/15.png": "3832",
	"./Hair/Light Brown/16.png": "1d24",
	"./Hair/Light Brown/17.png": "0a8a",
	"./Hair/Light Brown/18.png": "2216",
	"./Hair/Light Brown/19.png": "5aec",
	"./Hair/Light Brown/2.png": "9dee",
	"./Hair/Light Brown/20.png": "24f3",
	"./Hair/Light Brown/21.png": "fb4e",
	"./Hair/Light Brown/22.png": "a779",
	"./Hair/Light Brown/23.png": "921f",
	"./Hair/Light Brown/24.png": "a086",
	"./Hair/Light Brown/25.png": "00a2",
	"./Hair/Light Brown/26.png": "1bbc",
	"./Hair/Light Brown/27.png": "1126",
	"./Hair/Light Brown/28.png": "24d2",
	"./Hair/Light Brown/29.png": "a7df",
	"./Hair/Light Brown/3.png": "88e0",
	"./Hair/Light Brown/30.png": "a3c8",
	"./Hair/Light Brown/31.png": "db48",
	"./Hair/Light Brown/4.png": "c34e",
	"./Hair/Light Brown/5.png": "e0a7",
	"./Hair/Light Brown/6.png": "5e14",
	"./Hair/Light Brown/7.png": "53fc",
	"./Hair/Light Brown/8.png": "7f31",
	"./Hair/Light Brown/9.png": "5644",
	"./Hair/Light Green/0.png": "f996",
	"./Hair/Light Green/1.png": "7801",
	"./Hair/Light Green/10.png": "4026",
	"./Hair/Light Green/11.png": "604f",
	"./Hair/Light Green/12.png": "4ea1d",
	"./Hair/Light Green/13.png": "2697",
	"./Hair/Light Green/14.png": "0ee6",
	"./Hair/Light Green/15.png": "7ac1",
	"./Hair/Light Green/16.png": "df06",
	"./Hair/Light Green/17.png": "4b18",
	"./Hair/Light Green/18.png": "41f1",
	"./Hair/Light Green/19.png": "6645",
	"./Hair/Light Green/2.png": "a0d0",
	"./Hair/Light Green/20.png": "ad85",
	"./Hair/Light Green/21.png": "5c70",
	"./Hair/Light Green/22.png": "887f",
	"./Hair/Light Green/23.png": "4e03",
	"./Hair/Light Green/24.png": "68af",
	"./Hair/Light Green/25.png": "2c51",
	"./Hair/Light Green/26.png": "9de2",
	"./Hair/Light Green/27.png": "307d",
	"./Hair/Light Green/28.png": "b6c6",
	"./Hair/Light Green/29.png": "a9bd",
	"./Hair/Light Green/3.png": "0891",
	"./Hair/Light Green/30.png": "9cfd",
	"./Hair/Light Green/31.png": "0968",
	"./Hair/Light Green/4.png": "cea8",
	"./Hair/Light Green/5.png": "ccbf",
	"./Hair/Light Green/6.png": "b085",
	"./Hair/Light Green/7.png": "3b47",
	"./Hair/Light Green/8.png": "0b30",
	"./Hair/Light Green/9.png": "0485",
	"./Hair/Lilac/0.png": "7b2b",
	"./Hair/Lilac/1.png": "1da8",
	"./Hair/Lilac/10.png": "f2d8",
	"./Hair/Lilac/11.png": "2c05",
	"./Hair/Lilac/12.png": "4ab4",
	"./Hair/Lilac/13.png": "29cd",
	"./Hair/Lilac/14.png": "b838",
	"./Hair/Lilac/15.png": "7e90",
	"./Hair/Lilac/16.png": "93fd",
	"./Hair/Lilac/17.png": "3d11",
	"./Hair/Lilac/18.png": "a7a5",
	"./Hair/Lilac/19.png": "2240",
	"./Hair/Lilac/2.png": "c065",
	"./Hair/Lilac/20.png": "b49b",
	"./Hair/Lilac/21.png": "1197",
	"./Hair/Lilac/22.png": "4a2a",
	"./Hair/Lilac/23.png": "7ddf",
	"./Hair/Lilac/24.png": "fb22",
	"./Hair/Lilac/25.png": "00da",
	"./Hair/Lilac/26.png": "7912",
	"./Hair/Lilac/27.png": "0efb",
	"./Hair/Lilac/28.png": "7699",
	"./Hair/Lilac/29.png": "ad80",
	"./Hair/Lilac/3.png": "cfb4",
	"./Hair/Lilac/30.png": "7838",
	"./Hair/Lilac/31.png": "bee2",
	"./Hair/Lilac/4.png": "fedb",
	"./Hair/Lilac/5.png": "dfa7",
	"./Hair/Lilac/6.png": "71e0",
	"./Hair/Lilac/7.png": "077c",
	"./Hair/Lilac/8.png": "ac85",
	"./Hair/Lilac/9.png": "5277",
	"./Hair/Magenta/0.png": "6da3",
	"./Hair/Magenta/1.png": "3ee1",
	"./Hair/Magenta/10.png": "9294",
	"./Hair/Magenta/11.png": "11de",
	"./Hair/Magenta/12.png": "28a3",
	"./Hair/Magenta/13.png": "088f",
	"./Hair/Magenta/14.png": "27f9",
	"./Hair/Magenta/15.png": "f63e",
	"./Hair/Magenta/16.png": "e3ef",
	"./Hair/Magenta/17.png": "5c71",
	"./Hair/Magenta/18.png": "072f",
	"./Hair/Magenta/19.png": "841a",
	"./Hair/Magenta/2.png": "9505",
	"./Hair/Magenta/20.png": "672f",
	"./Hair/Magenta/21.png": "6ea1",
	"./Hair/Magenta/22.png": "47ff",
	"./Hair/Magenta/23.png": "12b9",
	"./Hair/Magenta/24.png": "b739",
	"./Hair/Magenta/25.png": "1a89",
	"./Hair/Magenta/26.png": "032a",
	"./Hair/Magenta/27.png": "f0f7",
	"./Hair/Magenta/28.png": "f6eb",
	"./Hair/Magenta/29.png": "2d98",
	"./Hair/Magenta/3.png": "bac4",
	"./Hair/Magenta/30.png": "66d0",
	"./Hair/Magenta/31.png": "774e",
	"./Hair/Magenta/4.png": "f8c8",
	"./Hair/Magenta/5.png": "5cc7",
	"./Hair/Magenta/6.png": "4850",
	"./Hair/Magenta/7.png": "b87c",
	"./Hair/Magenta/8.png": "b5d6",
	"./Hair/Magenta/9.png": "6939",
	"./Hair/Orange/0.png": "c55d",
	"./Hair/Orange/1.png": "7a5f",
	"./Hair/Orange/10.png": "fd5f",
	"./Hair/Orange/11.png": "83b5",
	"./Hair/Orange/12.png": "62ff",
	"./Hair/Orange/13.png": "557e",
	"./Hair/Orange/14.png": "186d",
	"./Hair/Orange/15.png": "b0b9",
	"./Hair/Orange/16.png": "2b4a",
	"./Hair/Orange/17.png": "8066",
	"./Hair/Orange/18.png": "bb6f",
	"./Hair/Orange/19.png": "0e07",
	"./Hair/Orange/2.png": "2c19",
	"./Hair/Orange/20.png": "1d66",
	"./Hair/Orange/21.png": "537b",
	"./Hair/Orange/22.png": "4bb6",
	"./Hair/Orange/23.png": "d91c",
	"./Hair/Orange/24.png": "1b46",
	"./Hair/Orange/25.png": "6077",
	"./Hair/Orange/26.png": "f840",
	"./Hair/Orange/27.png": "9ab7",
	"./Hair/Orange/28.png": "5c34",
	"./Hair/Orange/29.png": "9037",
	"./Hair/Orange/3.png": "eaf0",
	"./Hair/Orange/30.png": "b2d6",
	"./Hair/Orange/31.png": "144e",
	"./Hair/Orange/4.png": "b8cc",
	"./Hair/Orange/5.png": "6dc4",
	"./Hair/Orange/6.png": "f8da",
	"./Hair/Orange/7.png": "03f7",
	"./Hair/Orange/8.png": "02ea",
	"./Hair/Orange/9.png": "320e",
	"./Hair/Pink/0.png": "2b96",
	"./Hair/Pink/1.png": "cc92",
	"./Hair/Pink/10.png": "d9ed",
	"./Hair/Pink/11.png": "7f47",
	"./Hair/Pink/12.png": "2020",
	"./Hair/Pink/13.png": "d6e9",
	"./Hair/Pink/14.png": "c0744",
	"./Hair/Pink/15.png": "32e6",
	"./Hair/Pink/16.png": "ec31",
	"./Hair/Pink/17.png": "90d5",
	"./Hair/Pink/18.png": "92cd",
	"./Hair/Pink/19.png": "9af9",
	"./Hair/Pink/2.png": "040b",
	"./Hair/Pink/20.png": "b7d8",
	"./Hair/Pink/21.png": "1457",
	"./Hair/Pink/22.png": "d548",
	"./Hair/Pink/23.png": "0eaf",
	"./Hair/Pink/24.png": "d029",
	"./Hair/Pink/25.png": "5077",
	"./Hair/Pink/26.png": "e8cc",
	"./Hair/Pink/27.png": "be43",
	"./Hair/Pink/28.png": "95d9",
	"./Hair/Pink/29.png": "b6f8",
	"./Hair/Pink/3.png": "7568",
	"./Hair/Pink/30.png": "58aa",
	"./Hair/Pink/31.png": "f3f9",
	"./Hair/Pink/4.png": "85db",
	"./Hair/Pink/5.png": "57e2",
	"./Hair/Pink/6.png": "ae99",
	"./Hair/Pink/7.png": "6af8",
	"./Hair/Pink/8.png": "fd32",
	"./Hair/Pink/9.png": "bb75",
	"./Hair/Red/0.png": "712f",
	"./Hair/Red/1.png": "0b7f",
	"./Hair/Red/10.png": "7426",
	"./Hair/Red/11.png": "d75b",
	"./Hair/Red/12.png": "ae38",
	"./Hair/Red/13.png": "28d0",
	"./Hair/Red/14.png": "4113",
	"./Hair/Red/15.png": "15b0",
	"./Hair/Red/16.png": "585a",
	"./Hair/Red/17.png": "7493",
	"./Hair/Red/18.png": "9cfc",
	"./Hair/Red/19.png": "1b8e",
	"./Hair/Red/2.png": "c47b",
	"./Hair/Red/20.png": "09a5",
	"./Hair/Red/21.png": "7da4",
	"./Hair/Red/22.png": "290b",
	"./Hair/Red/23.png": "b9a3",
	"./Hair/Red/24.png": "7f6e",
	"./Hair/Red/25.png": "b8d5",
	"./Hair/Red/26.png": "c0a4",
	"./Hair/Red/27.png": "09c2",
	"./Hair/Red/28.png": "e5e3",
	"./Hair/Red/29.png": "e0a2",
	"./Hair/Red/3.png": "b94eb",
	"./Hair/Red/30.png": "1f1d",
	"./Hair/Red/31.png": "e88e",
	"./Hair/Red/4.png": "326f",
	"./Hair/Red/5.png": "65a6",
	"./Hair/Red/6.png": "c9e7",
	"./Hair/Red/7.png": "7f75",
	"./Hair/Red/8.png": "e6af",
	"./Hair/Red/9.png": "3374",
	"./Hair/White/0.png": "a7df7",
	"./Hair/White/1.png": "3fb3",
	"./Hair/White/10.png": "0b0d",
	"./Hair/White/11.png": "3e71",
	"./Hair/White/12.png": "181a",
	"./Hair/White/13.png": "81d4",
	"./Hair/White/14.png": "1fee",
	"./Hair/White/15.png": "7af0",
	"./Hair/White/16.png": "6cf0",
	"./Hair/White/17.png": "1aba",
	"./Hair/White/18.png": "9c04",
	"./Hair/White/19.png": "bcf4",
	"./Hair/White/2.png": "453a",
	"./Hair/White/20.png": "5171",
	"./Hair/White/21.png": "fc12",
	"./Hair/White/22.png": "7e1a",
	"./Hair/White/23.png": "1b94",
	"./Hair/White/24.png": "b96f",
	"./Hair/White/25.png": "0b81",
	"./Hair/White/26.png": "5f8c",
	"./Hair/White/27.png": "3967",
	"./Hair/White/28.png": "32ca",
	"./Hair/White/29.png": "e3be",
	"./Hair/White/3.png": "3fc2",
	"./Hair/White/30.png": "cc11",
	"./Hair/White/31.png": "c772",
	"./Hair/White/4.png": "3990",
	"./Hair/White/5.png": "8e0d",
	"./Hair/White/6.png": "e0df",
	"./Hair/White/7.png": "7111",
	"./Hair/White/8.png": "8a74",
	"./Hair/White/9.png": "8e4b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bdf5";